var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSilverstar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4313_15693)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M59.1097 33.7829C56.264 23.6524 45.8489 14.2617 45.8489 14.2617C37.1982 24.4491 32.702 33.6691 32.702 33.6691C22.7423 36.6285 13.75 47.0436 13.75 47.0436C23.7667 55.9221 32.702 60.1905 32.702 60.1905C35.5477 70.321 45.8489 79.8255 45.8489 79.8255C54.5566 69.6381 59.1097 60.3613 59.1097 60.3613C69.0695 57.4587 77.9479 47.0436 77.9479 47.0436C67.9881 38.1652 59.1097 33.7829 59.1097 33.7829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5161 35.0919C54.6705 24.9614 45.8489 14.2617 45.8489 14.2617C37.1982 24.4491 34.1249 35.0919 34.1249 35.0919C24.222 38.0514 13.75 47.0436 13.75 47.0436C23.7667 55.9221 34.1818 58.9954 34.1818 58.9954C37.0274 69.1259 45.8489 79.8255 45.8489 79.8255C54.5566 69.6381 57.5161 58.9954 57.5161 58.9954C67.4759 56.0928 77.9479 47.0436 77.9479 47.0436C67.9881 38.1652 57.5161 35.0919 57.5161 35.0919Z",
    fill: "#111422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7742 35.8315C54.0993 26.4978 45.847 16.7656 45.847 16.7656C37.7084 26.0994 34.9197 35.8315 34.9197 35.8315C25.5859 38.5064 15.7969 46.7588 15.7969 46.7588C25.1306 54.8973 34.9197 57.6861 34.9197 57.6861C37.5946 66.9629 45.847 76.752 45.847 76.752C53.9855 67.4182 56.7742 57.6861 56.7742 57.6861C66.0511 55.0112 75.897 46.7588 75.897 46.7588C66.5633 38.6202 56.7742 35.8315 56.7742 35.8315Z",
    fill: "#506374"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M42.6607 45.6211C40.498 44.1413 36.3433 39.133 35.262 36.2873C35.262 36.2873 35.262 36.2873 34.9205 35.832C26.3836 38.2793 17.5051 45.3365 16.0254 46.5886C16.1961 46.6455 16.4238 46.7024 16.6514 46.7593C28.4893 50.1741 44.8234 47.1008 42.6607 45.6211Z",
    fill: "#A7A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M48.8078 46.1333C46.8728 47.4423 65.1988 51.2555 75.8984 46.7593C66.5647 38.6208 56.7756 35.832 56.7756 35.832C57.5155 38.3362 50.7998 44.8243 48.8078 46.1333Z",
    fill: "#A7A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.5134 47.8975C17.5619 47.4991 29.8551 55.8084 33.7252 56.719C37.5953 57.6297 45.8477 45.7917 42.0345 46.7024C38.1645 47.6699 34.2944 48.865 22.5134 47.8975Z",
    fill: "#164197"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M22.0587 47.8404C16.8796 47.1575 24.506 48.125 30.9941 47.2713C37.4821 46.4176 42.832 45.2225 42.8889 46.1331C42.9458 47.0437 33.669 49.3771 22.0587 47.8404Z",
    fill: "#A7A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M36.4587 32.3623C35.8327 36.0047 42.6053 45.7938 43.8574 40.0456C45.1095 34.2974 47.9552 14.0363 43.8574 19.5C39.7597 24.9636 36.8571 30.1996 36.4587 32.3623Z",
    fill: "#A7A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M47.6687 36.288C46.6443 29.2877 45.3353 17.5636 48.124 20.58C50.9128 23.5964 55.5796 33.1009 55.6935 36.0034C55.8073 38.906 49.2623 47.2153 47.6687 36.288Z",
    fill: "#D4D8A6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M49.491 47.0456C48.182 46.7611 52.4505 55.8102 56.3775 57.0054C60.3045 58.2006 73.9636 48.753 68.7845 48.8099C63.6054 48.8668 57.4019 48.9807 53.9302 48.127C50.4016 47.2733 49.491 47.0456 49.491 47.0456Z",
    fill: "#164197"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M50.2306 47.2146C46.9296 46.4748 55.5235 47.9545 65.2556 47.2146C71.0608 46.8162 77.9472 46.3609 74.6463 47.2146C71.4022 48.1252 64.8572 50.4018 50.2306 47.2146Z",
    fill: "#A7A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M46.2464 45.1083C47.4416 47.8401 46.6448 34.181 46.8155 29.6849C46.8155 29.6849 59.564 43.8562 55.9785 33.3842C52.7345 24.9042 45.848 16.7656 45.848 16.7656C45.848 25.2457 44.4821 41.1244 46.2464 45.1083Z",
    fill: "#A7A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M46.2477 28.2635C46.0201 27.1821 44.9957 37.9387 45.6217 41.8657C46.2477 45.7927 46.8738 47.1586 46.8169 40.6136C46.76 34.0686 46.9307 31.5644 46.2477 28.2635Z",
    fill: "#A7A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.8879 57.687C35.2049 53.5323 44.3679 63.6059 45.8476 68.4435C45.8476 68.4435 49.3762 60.7603 53.0187 57.7439C56.6611 54.7275 55.2383 65.1995 45.5062 74.5901C45.5062 74.5332 37.1969 65.6548 35.8879 57.687Z",
    fill: "#164197"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M34.9765 57.6868C33.5537 53.2476 38.2206 48.9791 42.0337 46.7595C45.8469 44.5399 45.9607 47.4993 46.1315 54.3858C46.3022 61.2723 45.9038 76.8095 45.9038 76.8095C45.9038 76.8095 38.619 69.0694 34.9765 57.6868Z",
    fill: "#164197"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M50.0594 49.7176C48.8642 45.1077 61.7265 58.7668 56.3767 56.9456C51.0269 55.1813 50.0594 49.7176 50.0594 49.7176Z",
    fill: "#650056"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M46.1328 52.9639C46.2466 46.7604 47.2142 53.4761 47.7833 57.1755C48.3524 60.8179 46.1328 69.1841 46.1328 66.8507C46.1328 64.4604 46.1328 52.9639 46.1328 52.9639Z",
    fill: "#A7A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M54.6686 40.3854C57.5142 36.9706 74.3036 47.841 65.1975 48.2963C56.0914 48.7516 48.0097 47.6133 50.9692 44.8815C53.9287 42.2066 54.6686 40.3854 54.6686 40.3854Z",
    fill: "#D4D8A6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M30.0261 39.7596C34.1238 38.5644 44.0836 46.1907 40.4411 47.1583C36.7987 48.1258 25.4161 48.5811 22.9689 47.6136C20.5216 46.646 25.5868 41.0116 30.0261 39.7596Z",
    fill: "#D4D8A6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M46.2468 65.3117C46.133 67.076 52.2227 58.3683 52.9626 56.7747C53.7594 55.2381 47.5558 47.9532 46.4176 47.7825C45.2793 47.6117 46.2468 65.3117 46.2468 65.3117Z",
    fill: "#D4D8A6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6347 30.223C37.1433 25.5145 24.4263 24.4682 24.4263 24.4682C25.2715 36.823 30.1812 45.6766 30.1812 45.6766C25.4727 54.1679 24.3861 66.9252 24.3861 66.9252C36.7409 66.0801 45.6347 61.1301 45.6347 61.1301C54.0859 65.7983 66.8431 66.8849 66.8431 66.8849C65.998 54.5301 61.0883 45.6766 61.0883 45.6766C65.7565 37.2254 66.8833 24.4279 66.8833 24.4279C54.5285 25.2731 45.6347 30.223 45.6347 30.223Z",
    fill: "#506374"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M42.5762 47.127C40.0006 47.6099 33.5214 47.0062 30.7446 45.7587C30.7446 45.7587 30.7446 45.7587 30.1812 45.6782C25.8751 53.4452 24.5873 64.7134 24.4263 66.6451C24.5873 66.5646 24.7885 66.4439 24.9898 66.3231C35.775 60.3671 45.1518 46.644 42.5762 47.127Z",
    fill: "#A7A5A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M47.2847 43.1428C46.8421 45.4367 62.4968 35.1746 66.8834 24.4295C54.5286 25.2747 45.6348 30.2246 45.6348 30.2246C47.9286 31.4722 47.7677 40.8087 47.2847 43.1428Z",
    fill: "#A7A5A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.9395 62.9816C26.1566 66.2011 40.7248 63.3841 44.1052 61.2914C47.4857 59.1987 44.9503 44.9928 42.8979 48.333C40.8455 51.7537 38.954 55.3354 29.9395 62.9816Z",
    fill: "#164197"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M29.5777 63.2634C25.4326 66.4426 31.5094 61.7341 35.4935 56.5427C39.4776 51.3513 42.4154 46.7233 43.0996 47.3269C43.7837 47.9306 38.874 56.1403 29.5777 63.2634Z",
    fill: "#A7A5A5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M28.8136 42.1368C30.9465 45.1551 42.6574 47.288 39.4782 42.3381C36.2989 37.3881 23.9844 21.0492 24.9503 27.8101C25.9161 34.5711 27.5661 40.3259 28.8136 42.1368Z",
    fill: "#A7A5A5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M39.5185 36.9852C33.8441 32.7596 24.6283 25.3951 28.7332 25.556C32.838 25.717 42.8587 29.1377 44.9916 31.1097C47.1245 33.0816 48.372 43.5852 39.5185 36.9852Z",
    fill: "#D4D8A6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M48.4114 43.303C47.2846 44.0274 56.7016 47.4078 60.3235 45.4761C63.9454 43.5444 66.9234 27.2056 63.3015 30.908C59.6796 34.6104 55.3735 39.0774 52.315 40.9286C49.2163 42.8201 48.4114 43.303 48.4114 43.303Z",
    fill: "#164197"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M49.0558 42.9004C46.1985 44.7114 53.3216 39.6809 59.6801 32.2761C63.5032 27.8896 68.0507 22.6982 66.3203 25.6359C64.6703 28.5737 61.652 34.8115 49.0558 42.9004Z",
    fill: "#A7A5A5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M44.7499 44.2292C47.5267 45.3158 37.3048 36.2207 34.2463 32.9208C34.2463 32.9208 53.2815 33.9269 43.3414 29.0574C35.0512 25.355 24.4269 24.4696 24.4269 24.4696C30.4232 30.4659 40.6853 42.6597 44.7499 44.2292Z",
    fill: "#A7A5A5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M32.8369 32.3174C31.9113 31.7137 38.793 40.0442 42.0124 42.3783C45.2319 44.7124 46.6405 45.2356 41.9722 40.6478C37.3039 36.06 35.654 34.1686 32.8369 32.3174Z",
    fill: "#111422"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M46.3176 60.446C42.8969 57.9911 56.4993 58.635 60.9663 61.0094C60.9663 61.0094 58.0285 53.0814 58.4712 48.3729C58.9139 43.6644 65.3126 52.0753 65.0711 65.5972C65.0309 65.5569 52.8773 65.1545 46.3176 60.446Z",
    fill: "#164197"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M45.6754 61.0904C41.5303 58.9575 41.812 52.6393 42.9388 48.3735C44.0656 44.1076 46.2388 46.1198 51.229 50.8686C56.2192 55.6173 66.924 66.8855 66.924 66.8855C66.924 66.8855 56.2997 66.5636 45.6754 61.0904Z",
    fill: "#164197"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M50.7063 44.794C46.6015 42.3794 65.355 42.9428 60.2843 45.4379C55.2539 47.9732 50.7063 44.794 50.7063 44.794Z",
    fill: "#650056"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M50.222 49.8626C45.9159 45.3956 51.3488 49.4602 54.3671 51.6736C57.3451 53.8467 61.6914 61.332 60.0414 59.6821C58.3512 57.9918 50.222 49.8626 50.222 49.8626Z",
    fill: "#A7A5A5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M47.3658 34.9328C46.9633 30.506 66.5217 26.3207 60.4047 33.0816C54.2877 39.8425 47.7682 44.7522 47.9292 40.7279C48.1304 36.7438 47.3658 34.9328 47.3658 34.9328Z",
    fill: "#D4D8A6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M29.4964 51.9153C31.5488 48.1727 43.984 46.5227 42.0926 49.7824C40.2011 53.0421 32.4744 61.4128 30.0598 62.4591C27.6451 63.5055 27.2427 55.9397 29.4964 51.9153Z",
    fill: "#D4D8A6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M59.0343 58.5153C60.2014 59.8433 58.3502 49.38 57.7465 47.73C57.2233 46.08 47.6856 45.3154 46.76 45.9995C45.8344 46.6837 59.0343 58.5153 59.0343 58.5153Z",
    fill: "#D4D8A6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M60.4912 32.3174C61.4168 31.7137 54.5352 40.0442 51.3157 42.3783C48.0962 44.7124 46.6877 45.2356 51.3559 40.6478C56.0242 36.06 57.6742 34.1686 60.4912 32.3174Z",
    fill: "#111422"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M32.8369 59.8096C31.9113 60.4132 38.793 52.0828 42.0124 49.7487C45.2319 47.4145 46.6405 46.8914 41.9722 51.4791C37.3039 56.0669 35.654 57.9584 32.8369 59.8096Z",
    fill: "#111422"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M60.4912 59.8096C61.4168 60.4132 54.5352 52.0828 51.3157 49.7487C48.0962 47.4145 46.6877 46.8914 51.3559 51.4791C56.0242 56.0669 57.6742 57.9584 60.4912 59.8096Z",
    fill: "#111422"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4313_15693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.2548,
    height: 65.5069,
    fill: "white",
    transform: "translate(13.75 14.2617)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverstar);
export default __webpack_public_path__ + "static/media/silverstar.400ab56198cee641ea31f1a0dd529b7a.svg";
export { ForwardRef as ReactComponent };